<div class="row align-items-center selector-box">
  <div class="col-auto cursor-pointer" matRipple (click)="decrease()"><span [ngClass]="{'disable': current<=min}" class="mdi mdi-minus-circle-outline primary-color fs-24"></span></div>
  <div class="col-auto cursor-pointer" matRipple><span>{{current}}</span></div>
  <div class="col-auto cursor-pointer" matRipple (click)="increase()"><span [ngClass]="{'disable': current>=max}" class="mdi mdi-plus-circle-outline primary-color fs-24"></span></div>
</div>
